window.KRatingStore = function(params) {
	this.rating = params.rating;
	this.node = document.querySelector(`div[data-code="${params.code}"]`);
	this.stars = this.node.querySelector(".about-stores__items");
	this.starsColored = this.node.querySelector(".about-stores__items--colored");
	this.maxRating = 5;
	BX.ready(BX.delegate(this.init, this))
};

window.KRatingStore.prototype = {
	init: function () {
		this.setWidthColoredStars();
	},
	
	getWidthColoredStars: function() {
		let maxWidth = this.stars.clientWidth;
		return maxWidth * this.rating / this.maxRating;
	},
	
	setWidthColoredStars: function() {
		this.starsColored.style.width = this.getWidthColoredStars() + "%";
	},
};
